module.exports = __webpack_public_path__ + "img/img11.3871295.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/01/img11.png
// module id = 166
// module chunks = 0